import ConvergeIdentities from '@/views/studeo/ConvergeIdentities.vue'
import ConvergeIdentity from '@/views/studeo/ConvergeIdentity.vue'
import Bookings from '@/views/studeo/Bookings.vue'
import Booking from '@/views/studeo/Booking.vue'
import BookingPayments from '@/views/studeo/BookingPayments.vue'
import BookingPayment from '@/views/studeo/BookingPayment.vue'
import Enterprises from '@/views/studeo/Enterprises.vue'
import Enterprise from '@/views/studeo/Enterprise.vue'
import Amenities from '@/views/studeo/Amenities.vue'
import Features from '@/views/studeo/Features.vue'
import Integrations from '@/views/studeo/Integrations.vue'
import Integration from '@/views/studeo/Integration.vue'
import IntegrationCommission from '@/views/studeo/Integration/Commission.vue'
import IntegrationConnection from '@/views/studeo/Integration/Connection.vue'
import IntegrationLogs from '@/views/studeo/Integration/Logs.vue'
import IntegrationsLogs from '@/views/studeo/IntegrationsLogs.vue'
import IntegrationStatus from '@/views/studeo/IntegrationStatus.vue'
import PriceLabsStatus from '@/views/studeo/PriceLabsStatus.vue'
import IntegrationProfile from '@/views/studeo/Integration/Profile.vue'
import Leads from '@/views/studeo/Leads.vue'
import Resorts from '@/views/studeo/Resorts.vue'
import Resort from '@/views/studeo/Resort.vue'
import Reviews from '@/views/studeo/Reviews.vue'
import Review from '@/views/studeo/Review.vue'
import ResortComplex from '@/views/studeo/Resort/Complex.vue'
import ResortUnit from '@/views/studeo/Resort/Unit.vue'

import * as Breadcrumbs from '../breadcrumbs/studeo'

export default [
	{
		path: '/converge-identities',
		name: 'converge-identities',
		component: ConvergeIdentities,
		meta: {
			requiresAuth: true,
			title: 'Convege Identities',
			breadcrumb: [
				Breadcrumbs.ConvergeIdentities,
			],
		},
	},
	{
		path: '/converge-identities/:identity',
		name: 'converge-identity',
		component: ConvergeIdentity,
		meta: {
			requiresAuth: true,
			title: 'Convege Identities',
			breadcrumb: [
				Breadcrumbs.ConvergeIdentities,
				Breadcrumbs.ConvergeIdentity,
			],
		},
	},
	{
		path: '/integrations',
		name: 'integrations',
		component: Integrations,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumb: [
				Breadcrumbs.Integrations,
			],
		},
	},
	{
		path: '/integration/:integration',
		name: 'integration',
		component: Integration,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
			],
		},
	},
	{
		path: '/integration/:integration/logs',
		name: 'integration-logs',
		component: IntegrationLogs,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumbVariables: {
				tab: 'logs',
			},
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
			],
		},
	},
	{
		path: '/integration/:integration/:tab',
		name: 'integration-child',
		component: Integration,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
			],
		},
	},
	{
		path: '/integration/:integration/profiles/:profile',
		name: 'integration-profile',
		component: IntegrationProfile,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumbVariables: {
				tab: 'profiles',
			},
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
				Breadcrumbs.IntegrationProfile,
			],
		},
	},
	{
		path: '/integration/:integration/connections/:connection',
		name: 'integration-connection',
		component: IntegrationConnection,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumbVariables: {
				tab: 'connections',
			},
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
				Breadcrumbs.IntegrationConnection,
			],
		},
	},
	{
		path: '/integration/:integration/connections/:connection/:connectiontab',
		name: 'integration-connection-child',
		component: IntegrationConnection,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumbVariables: {
				tab: 'connections',
			},
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
				Breadcrumbs.IntegrationConnection,
				Breadcrumbs.IntegrationConnectionTab,
			],
		},
	},
	{
		path: '/integration/:integration/connections/:connection/commissions/:commission',
		name: 'integration-commission',
		component: IntegrationCommission,
		meta: {
			requiresAuth: true,
			title: 'Integrations',
			breadcrumbVariables: {
				tab: 'connections',
				connectiontab: 'commissions',
			},
			breadcrumb: [
				Breadcrumbs.Integrations,
				Breadcrumbs.Integration,
				Breadcrumbs.IntegrationTab,
				Breadcrumbs.IntegrationConnection,
				Breadcrumbs.IntegrationConnectionTab,
				Breadcrumbs.IntegrationCommission,
			],
		},
	},
	{
		path: '/integrations-logs',
		name: 'integrations-logs',
		component: IntegrationsLogs,
		meta: {
			requiresAuth: true,
			title: 'Integrations Logs',
			breadcrumb: [
				Breadcrumbs.IntegrationsLogs,
			],
		},
	},
	{
		path: '/integrations-status',
		name: 'integrations-status',
		component: IntegrationStatus,
		meta: {
			requiresAuth: true,
			title: 'Integrations Status',
			breadcrumb: [
				Breadcrumbs.IntegrationStatus,
			],
		},
	},
	{
		path: '/pricelabs-status',
		name: 'pricelabs-status',
		component: PriceLabsStatus,
		meta: {
			requiresAuth: true,
			title: 'PriceLabs Status',
			breadcrumb: [
				Breadcrumbs.PriceLabsStatus,
			],
		},
	},
	{
		path: '/studeo-bookings',
		name: 'studeo-bookings',
		component: Bookings,
		meta: {
			requiresAuth: true,
			title: 'Integration Bookings',
			breadcrumb: [
				Breadcrumbs.Bookings,
			],
		},
	},
	{
		path: '/studeo-bookings/:booking',
		name: 'studeo-booking',
		component: Booking,
		meta: {
			requiresAuth: true,
			title: 'Integration Bookings',
			breadcrumb: [
				Breadcrumbs.Bookings,
				Breadcrumbs.Booking,
			],
		},
	},
	{
		path: '/studeo-booking-payments',
		name: 'studeo-booking-payments',
		component: BookingPayments,
		meta: {
			requiresAuth: true,
			title: 'Integration Booking Payments',
			breadcrumb: [
				Breadcrumbs.BookingPayments,
			],
		},
	},
	{
		path: '/studeo-booking-payments/:booking_payment',
		name: 'studeo-booking-payment',
		component: BookingPayment,
		meta: {
			requiresAuth: true,
			title: 'Integration Booking Payments',
			breadcrumb: [
				Breadcrumbs.BookingPayments,
				Breadcrumbs.BookingPayment,
			],
		},
	},
	{
		path: '/studeo-enterprises',
		name: 'studeo-enterprises',
		component: Enterprises,
		meta: {
			requiresAuth: true,
			title: 'Studeo Enterprises',
			breadcrumb: [
				Breadcrumbs.Enterprises,
			],
		},
	},
	{
		path: '/studeo-enterprises/:enterprise',
		name: 'studeo-enterprise',
		component: Enterprise,
		meta: {
			requiresAuth: true,
			title: 'Studeo Enterprises',
			breadcrumb: [
				Breadcrumbs.Enterprises,
				Breadcrumbs.Enterprise,
			],
		},
	},
	{
		path: '/studeo-amenities',
		name: 'studeo-amenities',
		component: Amenities,
		meta: {
			requiresAuth: true,
			title: 'Studeo Amenities',
			breadcrumb: [
				Breadcrumbs.Amenities,
			],
		},
	},
	{
		path: '/studeo-features',
		name: 'studeo-features',
		component: Features,
		meta: {
			requiresAuth: true,
			title: 'Studeo Features',
			breadcrumb: [
				Breadcrumbs.Features,
			],
		},
	},
	{
		path: '/studeo-leads',
		name: 'studeo-leads',
		component: Leads,
		meta: {
			requiresAuth: true,
			title: 'Website Leads',
			breadcrumb: [
				Breadcrumbs.Leads,
			],
		},
	},
	{
		path: '/studeo-resorts',
		name: 'studeo-resorts',
		component: Resorts,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumb: [
				Breadcrumbs.Resorts,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort',
		name: 'studeo-resort',
		component: Resort,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort/:tab',
		name: 'studeo-resort-child',
		component: Resort,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
				Breadcrumbs.ResortTab,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort/complexes/:complex',
		name: 'studeo-resort-complex',
		component: ResortComplex,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumbVariables: {
				tab: 'complexes',
			},
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
				Breadcrumbs.ResortTab,
				Breadcrumbs.ResortComplex,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort/complexes/:complex/:ctab',
		name: 'studeo-resort-complex-child',
		component: ResortComplex,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumbVariables: {
				tab: 'complexes',
			},
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
				Breadcrumbs.ResortTab,
				Breadcrumbs.ResortComplex,
				Breadcrumbs.ResortComplexTab,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort/units/:unit',
		name: 'studeo-resort-unit',
		component: ResortUnit,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumbVariables: {
				tab: 'units',
			},
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
				Breadcrumbs.ResortTab,
				Breadcrumbs.ResortUnit,
			],
		},
	},
	{
		path: '/studeo-resorts/:resort/units/:unit/:utab',
		name: 'studeo-resort-unit-child',
		component: ResortUnit,
		meta: {
			requiresAuth: true,
			title: 'Studeo Resorts',
			breadcrumbVariables: {
				tab: 'units',
			},
			breadcrumb: [
				Breadcrumbs.Resorts,
				Breadcrumbs.Resort,
				Breadcrumbs.ResortTab,
				Breadcrumbs.ResortUnit,
				Breadcrumbs.ResortUnitTab,
			],
		},
	},
	{
		path: '/studeo-reviews',
		name: 'studeo-reviews',
		component: Reviews,
		meta: {
			requiresAuth: true,
			title: 'Reviews',
			breadcrumb: [
				Breadcrumbs.Reviews,
			],
		},
	},
	{
		path: '/studeo-reviews/:review',
		name: 'studeo-review',
		component: Review,
		meta: {
			requiresAuth: true,
			title: 'Review',
			breadcrumb: [
				Breadcrumbs.Reviews,
				Breadcrumbs.Review,
			],
		},
	},
]
